import { http } from "@/configurations/axios";

const post = (url, payload = {}) => http.post(url, payload);

export default {
  configuracao() {
    return http.get("/pos-controle/configuracao");
  },
  salvarConfiguracao(payload) {
    return post("/pos-controle/configuracao", payload);
  },
  testarConexao() {
    return post("/pos-controle/testar-conexao");
  },
  importarBaseInicial() {
    return post("/pos-controle/implantacao/importar");
  },
  sincronizarCatalogo(payload) {
    return post("/pos-controle/catalogo/sincronizar", payload);
  },
  baixarCatalogo() {
    return post("/pos-controle/catalogo/baixar");
  },
  sincronizarVendas(payload = {}) {
    return post("/pos-controle/vendas/sincronizar", payload);
  },
  listarVendas(payload = {}) {
    return post("/pos-controle/vendas/lista", payload);
  },
  detalharVenda(id) {
    return post("/pos-controle/vendas/detalhe", { id });
  },
  listarGrupos() {
    return post("/produtos/lista-grupo", { per_page: 1000 });
  },
  listarProdutos() {
    return post("/produtos");
  },
};
